import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Divider, Grid, Typography, useTheme } from '@mui/material';
import Modal from '@mui/material/Modal';
import strings from 'common/Translation/Translate';
import { useState } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';

type OrganisationDetailsProps = {
  venueListData: any;
};
const ViewOrgDetails = ({ venueListData }: OrganisationDetailsProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Box sx={{ py: 1 }}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}>
          <Typography variant="h6">
            <b>{venueListData.name}</b>
          </Typography>
          <InfoOutlined
            fontSize="small"
            color="primary"
            onClick={() => setOpen(true)}
            sx={{
              ':hover': { cursor: 'pointer' },
            }}
          />

          <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box
              sx={{
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '40vw',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 3,
                ':focus': { border: 0 },
              }}>
              <Grid
                container
                justifyContent={'space-between'}
                alignItems={'center'}
                px={1}
                mb={1}
                color={theme.palette.primary.main}>
                <Grid item>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    {strings.aboutTabText}
                  </Typography>
                </Grid>
                <Grid item>
                  <ClearOutlinedIcon onClick={() => setOpen(false)} sx={{ ':hover': { cursor: 'pointer' } }} />
                </Grid>
              </Grid>
              <Divider
                sx={{
                  borderStyle: 'dashed',
                  borderColor: theme.palette.secondary.main,
                }}
              />
              <Typography id="modal-modal-description" sx={{ mt: 2, px: 1, fontSize: '0.75rem' }}>
                {venueListData.description}
              </Typography>
            </Box>
          </Modal>
        </Box>
      </Box>
      <Divider sx={{ border: `0.5px solid ${theme.palette.primary.main}` }} />
    </>
  );
};

export default ViewOrgDetails;
